import { useCallback } from 'react';

import { drawLinks } from './draw-links.js';
import { drawNodes } from './draw-nodes.js';
import { useCurrentTheme } from '../../../core/hooks/useCurrentTheme.js';
import { useCanvas } from '../../core/components/canvas/hooks/useCanvas.js';
import { LINK_OPACITY_DARK, LINK_OPACITY_LIGHT } from '../constants.js';
import type { SankeyLayoutModel } from '../types/sankey-internal.js';

export function useDrawSankey(
  layout: SankeyLayoutModel,
  nodeColors: Map<string, string>,
): void {
  const theme = useCurrentTheme();

  const draw = useCallback(
    (ctx: CanvasRenderingContext2D) => {
      const linkOpacity =
        theme === 'dark' ? LINK_OPACITY_DARK : LINK_OPACITY_LIGHT;
      drawLinks(ctx, layout.links, nodeColors, linkOpacity);
      drawNodes(ctx, layout.nodes, nodeColors);
    },
    [layout, nodeColors, theme],
  );

  useCanvas('sankey', draw);
}
